import { TreePillsInput, TreePillsInputProps } from "./tree-pills-input"
import { Empty } from "../../@client/Theasoft_ApiServer__Utils_TreeBase"
import { useTranslation } from "react-i18next"
import { useGetContractTypeTreeSuspense } from "@/orval/gen"

export interface ContractTypeTreeSelectProps extends Omit<
  TreePillsInputProps<Empty>,
  "tree"
> {
  withRoot?: boolean
}

export function ContractTypeTreeSelect({
  withRoot = true,
  ...props
}: ContractTypeTreeSelectProps) {
  const { i18n, t } = useTranslation("app_server")
  const { data } = useGetContractTypeTreeSuspense({
    withRoot,
    lang: i18n.language,
  })
  return <TreePillsInput label={t("ContractTypes")} {...data} {...props} />
}
